import React, { lazy } from "react";

const AccountPage = lazy(() => import("./AccountPage"));
const ClientInvitePage = lazy(() => import("./ClientInvitePage"));
const ClientsAdminPage = lazy(() => import("./ClientsAdminPage"));
const InvoicePage = lazy(() => import("./InvoicePage"));
const ResetPasswordPage = lazy(() => import("./ResetPasswordPage"));

export { AccountPage, ClientInvitePage, ClientsAdminPage, InvoicePage, ResetPasswordPage };
